import styled from 'styled-components'
import { TransitionsAnim } from 'animations/Transitions'
import { CloseWrapperProps } from './interfaces'

const { iconRotate } = TransitionsAnim()

export const HeaderWrapper = styled.header<CloseWrapperProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
  height: 36px;
  min-width: 315px;
  h1 {
    text-transform: uppercase;
    font-size: 26px;
  }
  svg {
    width: 36px;
    height: 36px;
    padding: 7px;
    border-radius: 18px;
    border: solid 3px;
    cursor: pointer;
    border-color: ${({ borderColor }) => borderColor};
    background-color: ${({ background }) => background};
    stroke: ${({ strokeColor }) => strokeColor};
    ${iconRotate};
  }
`
export const CloseWrapper = styled.div<CloseWrapperProps>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  border-radius: 18px;
  border: solid 3px;
  cursor: pointer;
  border-color: ${({ borderColor }) => borderColor};
  background-color: ${({ background }) => background};
  svg {
    stroke: ${({ strokeColor }) => strokeColor};
    ${iconRotate};
  }
`
